import { Button, Flex, Form, Input, Typography } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface FormItemInputProps {
	buttonText: string;
	label?: string;
	isLoading?: boolean;
	fullWidth?: boolean;
	onSubmit: (value: string) => void;
	onChange?: (value: string) => void;
	disabled?: boolean;
	valueToCompare?: string[];
	compareErrorMessage?: string;
}

function CompoundElement({
	label,
	buttonText,
	isLoading,
	fullWidth,
	disabled,
	valueToCompare,
	compareErrorMessage,
	onSubmit,
	onChange,
}: FormItemInputProps) {
	const { t } = useTranslation();
	const [nationalId, setNationalId] = useState<string>('');
	const [error, setError] = useState<string | null>(null);

	const validate = (value: string): boolean => {
		if (!value) {
			setError(t('COMMON.FIELD_REQUIRED'));
			return false;
		}
		if (value.length !== 10) {
			setError(t('COMMON.NATIONAL_ID_LENGTH'));
			return false;
		}

		if (valueToCompare && valueToCompare.includes(value)) {
			if (compareErrorMessage) {
				setError(compareErrorMessage);
				return false;
			}

			valueToCompare[0] === value ? setError(t('ACTIONS.CANT_USED_DECEASED_NATIONAL_ID')) : setError(t('COMMON.CANT_USED_MULTIPLE'));
			return false;
		}
		setError(null);
		return true;
	};

	const changeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		setNationalId(e.target.value);
		validate(e.target.value);
		onChange && onChange(e.target.value);
	};

	const submitHandler = () => {
		if (error || !validate(nationalId)) return;
		onSubmit(nationalId);
	};

	return (
		<div className="compoundInput mb-2">
			{label && <Typography style={{ fontSize: 15, marginBottom: 5 }}>{label}</Typography>}
			<Flex
				align="center"
				justify="space-between"
				style={{
					border: '1px solid #e5e5e5',
					borderRadius: 'var(--radius)',
					padding: '2px 5px',
					maxWidth: fullWidth ? 'unset' : 'var(--inputWidth)',
				}}>
				<Input
					variant="borderless"
					type="number"
					onChange={changeHandler}
					onKeyUp={(e) => e.key === 'Enter' && submitHandler()}
					onWheel={(e) => e.currentTarget.blur()}
				/>
				<Button type="primary" onClick={submitHandler} size="middle" disabled={disabled} loading={isLoading}>
					{buttonText}
				</Button>
			</Flex>
			{error && (
				<Typography.Text style={{ fontSize: 15, position: 'absolute' }} type="danger">
					{error}
				</Typography.Text>
			)}
		</div>
	);
}

export default CompoundElement;
